import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { CompressionService } from '../compression.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-word-compression',
  templateUrl: './t-word-compression.component.html',
  styleUrls: ['./t-word-compression.component.css']
})
export class TWordCompressionComponent extends GeneralTeacherComponent {

  text: string;
  highlight: boolean = false;
  absolute: boolean = false;
  relative: boolean = false;

  compressedText: string = "";

  possibleTexts: string[] = [];

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected compressionService: CompressionService, protected http: HttpClient) {
    super(topicService, activatedRoute)
    this.type = "wordCompression";
    this.title = this.get("wordCompression");
    this.loadText();
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(textFile)
        .subscribe(response => {
          self.possibleTexts = response.repeatedTexts;
          console.log(self.possibleTexts)
          resolve(true);
        })
    })
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.text = this.configuration.typespecifics.text;
    this.highlight = this.configuration.typespecifics.highlight;
    this.absolute = this.configuration.typespecifics.absolute;
    this.relative = this.configuration.typespecifics.relative;

    this.compressedText = this.compressionService.compress(this.text, this.absolute, this.relative);
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/wordCompression.png";
    definition.level = this.relative ? 3 : 2;
    definition.key = "compression%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.text = this.text.trim();
    definition.typespecifics.highlight = this.highlight;
    definition.typespecifics.absolute = this.absolute;
    definition.typespecifics.relative = this.relative;
    definition.key = definition.key.concat("%", this.text, "%", this.absolute.toString(), "%", this.relative.toString());

    return definition;
  }

  reset() {
    super.reset();
    this.title = this.get("wordCompression");
    this.absolute = false;
    this.relative = false;
    this.highlight = false;
    this.text = "";
    this.compressedText = "";

  }

  /** normalize the text and compute the compressed Text */
  normalizeText() {
    this.text = this.text.replace(/[^A-z ]/gi, '').replace(/\s+/gi, ' ').toUpperCase();
    this.compressedText = this.compressionService.compress(this.text, this.absolute, this.relative);
  }

  generate() {
    this.title = this.get("wordCompression");
    this.highlight = Math.random() > 0.5;
    this.absolute = Math.random() > 0.3;
    this.relative = this.absolute ? (Math.random() > 0.8) : true;
    this.generateText();
  }


  /** generate a Text */
  generateText() {
    let index = Math.floor(Math.random() * this.possibleTexts.length);
    this.text = this.possibleTexts[index];
    this.normalizeText();
  }

}
